import {TableHead, TableRow, TableCell, Box} from "@mui/material";
import SortableFilterableHeaderCell from "../headerCells/SortableFilterableHeaderCell";
import NumberComparisonFilterHeader from "../headerCells/NumberComparisonFilterHeader";
import SelectFilterableHeaderCell from "../headerCells/SelectFilterableHeaderCell";
import CustomCheckbox from "../../../../../../../components/Checkbox";

const ExtraBidHeader = ({
    hotelOrGroupType,
    allSelected,
    someSelected,
    onSelectAll,
    sortConfig,
    onSortChange,
    filters,
    onFilterChange,
    data,
    hasDeletableRow
}) => (
    <TableHead>
        <TableRow>
            <TableCell>
                <Box display="flex" alignItems="center">
                    {hasDeletableRow && (
                        <CustomCheckbox
                            checked={allSelected}
                            onChange={onSelectAll}
                            checkboxStyles={{ padding: "2px 0 2px 9px" }}
                        />
                    )}
                    <SortableFilterableHeaderCell
                        label={`${hotelOrGroupType} Name`}
                        columnKey="label_entity"
                        sortConfig={sortConfig}
                        onSortChange={onSortChange}
                        filterValue={filters.label_entity}
                        onFilterChange={onFilterChange}
                        disableFilter={true}
                        hasCheckBox={hasDeletableRow}
                    />
                </Box>
            </TableCell>
            <TableCell>
                <SelectFilterableHeaderCell
                    label="Device"
                    columnKey="label_device"
                    sortConfig={sortConfig}
                    onSortChange={onSortChange}
                    filterValue={filters.label_device}
                    onFilterChange={onFilterChange}
                    options={[...new Set(data?.map(row => row.label_device))]}
                />
            </TableCell>
            <TableCell>
                <NumberComparisonFilterHeader
                    label="Extra Bids"
                    columnKey="extra_bids_value"
                    sortConfig={sortConfig}
                    onSortChange={onSortChange}
                    filterValue={filters.extra_bids}
                    onFilterChange={onFilterChange}
                />
            </TableCell>
            <TableCell />
        </TableRow>
    </TableHead>
);

export default ExtraBidHeader;
